import React, { useEffect, useState } from 'react';
import upperFirst from 'lodash/upperFirst';
import { Button, Typography, useStateInRef } from 'seagull';
import { useIsMounted } from "../../hooks/useIsMounted";
import { ErrorBox, SuccessBox, ImportCard } from "./CommonComponents";
import styles from "./ImportWizard.module.scss";

function ProgressBar(props) {
  const {
    min,
    max,
    current
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.progressBar
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "".concat((current - min) / (max - min) * 100, "%")
    }
  }));
}

export default function SaveItemsStep(props) {
  const {
    saveEntityName,
    items,
    testid,
    currentSaveData,
    onReset,
    onEvent
  } = props;
  const isMounted = useIsMounted();
  const getStateInRef = useStateInRef(props);
  const [numberOfSavedItems, setNumberOfSavedItems] = useState(0);
  const [uploading, setUploading] = useState(true);
  const [saveFailed, setSaveFailed] = useState(false);
  const currentSaveNumSaved = currentSaveData ? currentSaveData.saved : numberOfSavedItems;
  const currentSaveEntityName = currentSaveData ? currentSaveData.entity : saveEntityName;
  const currentSaveTotal = currentSaveData ? currentSaveData.total : items.length;
  useEffect(() => {
    const {
      items,
      onStartSave
    } = getStateInRef();

    const saveItems = async () => {
      let failedToSaveSomeDraft = false;
      let numOfSavedDrafts = 0;

      if (onStartSave) {
        try {
          await onStartSave(items);
        } catch (err) {
          setUploading(false);
          return setSaveFailed(true);
        }
      }

      for (const item of items) {
        try {
          await getStateInRef().saveItem(item, numOfSavedDrafts, items);
          numOfSavedDrafts = numOfSavedDrafts + 1;
          setNumberOfSavedItems(numOfSavedDrafts);
        } catch (err) {
          failedToSaveSomeDraft = true;
        }
      }

      const {
        onEvent
      } = getStateInRef();
      onEvent && onEvent(failedToSaveSomeDraft ? 'afterSaveFailure' : 'afterSaveSuccess');
      setUploading(false);
      setSaveFailed(failedToSaveSomeDraft);
    };

    if (isMounted() && items) {
      saveItems();
    }
  }, []);
  return /*#__PURE__*/React.createElement(ImportCard, {
    title: "Saving ".concat(upperFirst(currentSaveEntityName)),
    actionsEnd: /*#__PURE__*/React.createElement(React.Fragment, null, saveFailed && /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      disabled: uploading,
      onClick: onReset
    }, "Restart"), /*#__PURE__*/React.createElement(Button, {
      "data-testid": testid && testid + '-redirect-to-items',
      disabled: uploading || saveFailed,
      onClick: () => onEvent && onEvent('redirectToItems')
    }, "View ", saveEntityName))
  }, saveFailed ? /*#__PURE__*/React.createElement(ErrorBox, {
    "data-testid": testid && testid + '-save-error'
  }, "Failed to save ", currentSaveEntityName, ". Please reset and start over.", !!(currentSaveData !== null && currentSaveData !== void 0 && currentSaveData.errorMsg) && /*#__PURE__*/React.createElement("div", {
    "data-testid": testid && testid + '-save-error-msg'
  }, "Error: ", currentSaveData.errorMsg)) : uploading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProgressBar, {
    min: 0,
    max: currentSaveTotal,
    current: currentSaveNumSaved
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.progressStatus
  }, /*#__PURE__*/React.createElement(Typography, null, "Uploading and creating ", currentSaveEntityName, ". Please don't close this tab."), /*#__PURE__*/React.createElement(Typography, {
    skin: "disabled"
  }, "".concat(currentSaveNumSaved, " / ").concat(currentSaveTotal, " ").concat(currentSaveEntityName)))) : /*#__PURE__*/React.createElement(SuccessBox, {
    "data-testid": testid && testid + '-save-success'
  }, upperFirst(saveEntityName), " created successfully."));
}